// TitleSection component
export const TitleSection = ({logo}) => (
    <div className="d-flex align-items-center justify-content-center text-left title-section w-100">
        <div className='logo-container'>
            {/* <h1 className="text-light">DATA MOOVER</h1>
            <h3 className="text-dark">Moove your data with ease</h3> */}
            {logo && (
                <img src={logo} className='landing-logo' />
            )}
        </div>
    </div>
);